export const DEFAULT_PAYER_ID = 'customer';
export const PAYER_DETAILS_SOURCE = 'payers-details';
export const PAYER_DASHBOARD_SOURCE = 'payers-dashboard';

export const INTEGRATION_VALUE_ERROR = 'PAYER_CODE_ALREADY_USED';
